import React from "react";
import {
  RegisterMain,
  RegisterHead,
  RegisterCard,
  RegisterDiv,
} from "./AuthStyles";
import Header from "../../components/Header";
import MobileNav from "../../components/MobileNav";
import Footer from "../../components/Footer";
import { Link } from "react-router-dom";

const Forgot = () => {
  return (
    <div className="bg">
      <Header />
      <MobileNav />
      <RegisterMain>
        <RegisterHead>
          <h2>Forgot Password</h2>
        </RegisterHead>
        <RegisterCard>
          <RegisterDiv>
            <div className="formDiv">
              <label>Enter Your Email Id</label>
              <input type="email" />
            </div>
            <Link to="/forgot-otp">
              <button>Send Otp</button>
            </Link>
          </RegisterDiv>
        </RegisterCard>
      </RegisterMain>
      <Footer />
    </div>
  );
};

export default Forgot;
